import each from 'lodash/each';

import RouteCollection from 'zoomforth_zf/models/route.collection.js';

import domainsStore from './domains.js';

var routeCollectionsByPageId;

const init = function(sourceRouteCollection) {

  const rebuild = ()=> {
    routeCollectionsByPageId = {};
    each(sourceRouteCollection.groupBy('resource_id'), (routeSetForPage, pageId)=> {
      routeCollectionsByPageId[parseInt(pageId)] = new RouteCollection(routeSetForPage, { domains:domainsStore.get() });
    });
  };

  rebuild();
  sourceRouteCollection.on('add', (route)=> {
    const pageId = route.get('resource_id');
    if (!routeCollectionsByPageId[pageId]) {
      routeCollectionsByPageId[pageId] = new RouteCollection([route], { domains:domainsStore.get() });
    } else {
      routeCollectionsByPageId[pageId].add(route);
    }

  });
  
  sourceRouteCollection.on('remove', (route)=> {
    const pageId = route.get('resource_id');
    routeCollectionsByPageId[pageId].remove(route);
  });

  sourceRouteCollection.on('reset', rebuild);

  return routeCollectionsByPageId;
};

const get = function(pageId) {
  if (!routeCollectionsByPageId) {
    throw new Error('You must call `init` on appglobal singleton before calling `get`');
  }
  if (!routeCollectionsByPageId[pageId]) {
    routeCollectionsByPageId[pageId] = new RouteCollection([], { domains:domainsStore.get() });
  }
  return routeCollectionsByPageId[pageId];
};



export { get, init };
export default { get, init };
